export default "__VITE_ASSET__BG8x0siq__"